<script lang="ts" setup>
withDefaults(
  defineProps<{ heading: string; subtitle?: string; headingLevel?: string }>(),
  {
    headingLevel: "h2",
    subtitle: undefined,
  },
);
</script>

<template>
  <div class="flex flex-col gap-y-[5px]">
    <p v-if="subtitle" class="font-helvetica-bold">{{ subtitle }}</p>
    <component
      :is="headingLevel"
      class="text-[25px] font-helvetica-light lg:text-[33px] leading-[120%] md:whitespace-pre-line"
    >
      {{ heading }}
    </component>
  </div>
</template>
